(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    var filterLink = event.target.closest('[data-ry-resource-filter]');
    if (!filterLink) return;

    var collectionRoot = filterLink.closest('.collection-template');
    if (!collectionRoot) return;

    var filter = filterLink.getAttribute('data-ry-resource-filter');
    var cards = collectionRoot.querySelectorAll('[data-ry-resource-card]');
    if (!cards.length) return;

    event.preventDefault();

    collectionRoot.querySelectorAll('[data-ry-resource-filter]').forEach(function(link) {
      link.setAttribute('aria-pressed', link === filterLink ? 'true' : 'false');
    });

    cards.forEach(function(card) {
      var groups = (card.getAttribute('data-ry-resource-groups') || '').split(/\s+/);
      var shouldShow = filter === 'all' || groups.indexOf(filter) !== -1;
      card.hidden = !shouldShow;
    });

    var productGrid = collectionRoot.querySelector('#CollectionProducts');
    if (productGrid) productGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initializeRainbowMenuKeyboard() {
    document.querySelectorAll('.ry-site-header').forEach(function (header) {
      if (header.dataset.ryMenuKeyboardReady === 'true') return;
      header.dataset.ryMenuKeyboardReady = 'true';
      header.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var menu = event.target.closest('.ry-site-nav__details[open], .ry-mobile-menu[open]');
        if (!menu || !header.contains(menu)) return;
        menu.removeAttribute('open');
        var summary = menu.querySelector(':scope > summary');
        if (summary) summary.focus();
        event.preventDefault();
        event.stopPropagation();
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeRainbowMenuKeyboard, { once: true });
  } else {
    initializeRainbowMenuKeyboard();
  }
  document.addEventListener('shopify:section:load', initializeRainbowMenuKeyboard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ry-class-builder-launch"]) return;
  try {
    
document.querySelectorAll('[data-rycb-launch]').forEach(function(root){
  var select=root.querySelector('[data-rycb-variant]');
  if(!select)return;
  var deadline=Date.parse(root.dataset.rycbOfferEnd);
  var unavailable=root.dataset.rycbUnavailable;
  function syncChoice(){
    var option=select.options[select.selectedIndex];
    if(!option)return;
    root.querySelector('[data-rycb-price]').textContent=option.dataset.price;
    root.querySelector('[data-rycb-note]').textContent=option.disabled?unavailable:option.dataset.note;
    root.querySelector('[data-rycb-add]').disabled=option.disabled||option.dataset.available!=='true';
  }
  function expireFounding(){
    if(Date.now()<deadline)return;
    root.querySelectorAll('[data-rycb-founding-copy]').forEach(function(el){el.hidden=true;});
    Array.from(select.options).forEach(function(option){
      if(option.dataset.founding!=='true')return;
      if(!option.disabled)option.textContent+=' - '+unavailable;
      option.disabled=true;
      option.dataset.available='false';
    });
    syncChoice();
  }
  select.addEventListener('change',function(){expireFounding();syncChoice();var url=new URL(window.location.href);url.searchParams.set('variant',select.value);window.history.replaceState({},'',url);});
  select.form.addEventListener('submit',function(event){
    expireFounding();
    var option=select.options[select.selectedIndex];
    if(!option||option.disabled||option.dataset.available!=='true'){event.preventDefault();event.stopImmediatePropagation();select.focus();}
  },true);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)expireFounding();});
  expireFounding();
  syncChoice();
  var remaining=deadline-Date.now();
  if(remaining>0&&remaining<2147483647)setTimeout(expireFounding,remaining+20);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ry-rebuild-cart"]) return;
  try {
    
(() => {
  function setupOffers(root) {
    if (root.dataset.ready || !window.fetch) return;
    root.dataset.ready = 'true';
    const state = JSON.parse(root.querySelector('[data-ry-offer-state]').textContent);
    const cards = Array.from(root.querySelectorAll('[data-ry-offer]'));
    const buttons = Array.from(root.querySelectorAll('[data-ry-offer-add]'));
    const more = root.querySelector('[data-ry-offer-more]');
    const status = root.querySelector('[data-ry-offer-status]');
    const base = (root.dataset.root || '/').replace(/\/?$/, '/');
    const form = root.closest('form');
    const initialForm = form ? Array.from(form.querySelectorAll('input[name="updates[]"], textarea[name="note"]')).map(input => [input, input.value]) : [];
    let page = 0;
    let busy = false;
    const mobile = window.matchMedia('(max-width:640px)');
    const pageSize = () => mobile.matches ? 1 : 3;
    const draw = () => {
      const size=pageSize();
      cards.forEach((card,index)=>{const visible=Math.floor(index/size)===page;card.hidden=!visible;card.toggleAttribute('data-ry-visible',visible);});
      if(more){more.hidden=cards.length<=size;more.firstChild.textContent=(page===Math.ceil(cards.length/size)-1 ? state.messages.back : state.messages.more)+' ';}
    };
    draw();
    mobile.addEventListener('change',()=>{page=0;draw();});
    buttons.forEach(button => { button.hidden = false; });
    if (more) {
      more.addEventListener('click', () => {
        if (busy) return;
        page = (page + 1) % Math.ceil(cards.length / pageSize());
        draw();
        const first = cards[page * pageSize()].querySelector('h3 a');
        first.focus({preventScroll:true});
        root.scrollIntoView({block:'start',behavior:'auto'});
      });
    }
    const fingerprint = cart => JSON.stringify({items:cart.items.map(item=>({key:item.key,id:item.variant_id || item.id,quantity:item.quantity})),total:cart.total_price ?? cart.total});
    async function request(path, body) {
      const response = await fetch(base + path, {method:body ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json',...(body ? {'Content-Type':'application/json'} : {})}, ...(body ? {body:JSON.stringify(body)} : {})});
      if (!response.ok) throw new Error(state.messages.error);
      return response.json();
    }
    buttons.forEach(button => button.addEventListener('click', async () => {
      if (busy) return;
      if (initialForm.some(([input,value])=>input.value !== value)) { status.textContent=state.messages.unsaved; return; }
      busy=true;
      buttons.forEach(item=>{item.disabled=true;});
      if (more) more.disabled=true;
      status.textContent=state.messages.busy;
      try {
        const current=await request('cart.js');
        if (fingerprint(current) !== fingerprint(state)) throw new Error(state.messages.changed);
        const card=button.closest('[data-ry-offer]');
        const id=Number(card.dataset.variantId);
        if (current.items.some(item=>Number(item.product_id)===Number(card.dataset.productId))) throw new Error(state.messages.changed);
        if (card.dataset.replaceKey) {
          const source=current.items.find(item=>item.key===card.dataset.replaceKey);
          const reportingKeys = ["_Reporting product", "_Reporting product handle", "_Reporting revenue class", "_RY First Source", "_RY First Medium", "_RY First Campaign", "_RY First Content", "_RY First Term", "_RY First Google click ID", "_RY First Meta click ID", "_RY First OpenAI click reference", "_RY First Landing page", "_RY First Referrer", "_RY First Captured at", "_RY Last non-direct Source", "_RY Last non-direct Medium", "_RY Last non-direct Campaign", "_RY Last non-direct Content", "_RY Last non-direct Term", "_RY Last non-direct Google click ID", "_RY Last non-direct Meta click ID", "_RY Last non-direct OpenAI click reference", "_RY Last non-direct Landing page", "_RY Last non-direct Referrer", "_RY Last non-direct Captured at"];
          if (!source || source.quantity!==1 || source.selling_plan_allocation || Object.keys(source.properties || {}).some(key => !reportingKeys.includes(key))) throw new Error(state.messages.changed);
          const updates = {[source.key]:0,[id]:1};
          const attributes = {};
          if (form) form.querySelectorAll('input[name^="attributes[RY "]').forEach(input => {
            const key = input.name.slice(11, -1);
            if (reportingKeys.includes('_' + key) && input.value) attributes[key] = input.value.slice(0, 255);
          });
          const updated = await request('cart/update.js',{updates,attributes});
          if (updated.items.some(item=>item.key===source.key) || !updated.items.some(item=>item.variant_id===id && item.quantity===1)) throw new Error(state.messages.error);
        } else {
          await request('cart/add.js',{items:[{id,quantity:1}]});
        }
        window.location.assign(root.dataset.cartUrl || base+'cart');
      } catch (error) {
        status.textContent=error.message || state.messages.error;
        busy=false;
        buttons.forEach(item=>{item.disabled=false;});
        if (more) more.disabled=false;
      }
    }));
  }
  const start=()=>document.querySelectorAll('[data-ry-addons]').forEach(setupOffers);
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
  document.addEventListener('shopify:section:load',start);
})();

  } catch(e) { console.error(e); }
})();
})();
